// extracted by mini-css-extract-plugin
export default {"input-group":"AppDisplay_input-group__kYZrv","input-container":"AppDisplay_input-container__fIzpQ","input-inline":"AppDisplay_input-inline__UJMXE"};